export const blockIconsAudioandvideoVolumeUp = (
	<span className='material-symbols-outlined'>volume_up</span>
);
